import { render } from "./TourDiyTab.vue?vue&type=template&id=01f28870"
import script from "./TourDiyTab.vue?vue&type=script&lang=js"
export * from "./TourDiyTab.vue?vue&type=script&lang=js"
script.render = render

export default script